import { AdminPageContent, AdminPageHeader } from "@/components/admin";
import { useBreadcrumb } from "@/contexts/shared/breadcrumb";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { useMountEffect } from "@react-hookz/web";
import { DocumentSectionTypesTable } from "./DocumentSectionTypesTable";

const DocumentSectionTypes = () => {
    const { setBreadcrumbs } = useBreadcrumb();

    useDocumentTitle("Document Section Types");

    useMountEffect(() => {
        setBreadcrumbs([
            { label: "Admin", path: "home" },
            { label: "Document Section Types" },
        ]);
    });

    return (
        <AdminPageContent>
            <AdminPageHeader
                title="Document Section Types"
                subtitle="Define how document sections are classified"
            />

            <div className="mt-6">
                <DocumentSectionTypesTable />
            </div>
        </AdminPageContent>
    );
};

export default DocumentSectionTypes;
